import { Form, Input } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useCallback, useEffect, useState } from 'react';
import { useRequestContext } from './Request.Provider';
import { RequestComments } from './RequestComments';

const exceptionCategory = [
  'ddc7cc8b-2808-40e5-84a9-97ef0fc008fb', // Нічні роботи
  '5f72e68a-8bbb-4660-b442-e36df955db2e', // Переміщення товару
  '5369e6b8-4f16-45b3-8114-bdeeb2ca4969', // Маркетингові роботи
  '88a699c2-b2de-4bde-9ffd-c038a9a174f9', // Тимчасовий вхід
];

const workServiceCategory = 'ddc7cc8b-2808-40e5-84a9-97ef0fc008fb';
const movingGoodsServiceCategory = '5f72e68a-8bbb-4660-b442-e36df955db2e';
const marketingServiceCategory = '5369e6b8-4f16-45b3-8114-bdeeb2ca4969';
const temporaryEntryServiceCategory = '88a699c2-b2de-4bde-9ffd-c038a9a174f9';

export const RequestCreateContainer = (props) => {
  const [filteredSubServiceCategory, setFiltredSubServiceCategory] = useState([]);
  const {
    formContentItem,
    requests,
    PrepareSelect,
    prepareSelectOptions,
    disabledForm,
    currentServiceCategory,
    isContractorStore,
  } = props;

  const { availableRequestFields, form } = useRequestContext();

  // Підрядник бачить лише Маркетингові роботи + Роботи
  // Торгова точка бачить всі категорії
  const contractorAllowedCategories = [workServiceCategory, marketingServiceCategory];

  const filterServiceCategory = requests?.ServiceCategory?.filter(({ Id }) =>
    exceptionCategory.includes(Id)
  )?.filter(({ Id }) => !isContractorStore || contractorAllowedCategories.includes(Id));

  // Extract dynamic form value to stable variable for effect deps
  const serviceCategoryValue = form.getFieldValue('ServiceCategory');

  useEffect(() => {
    const categoryId = availableRequestFields?.Category?.value || serviceCategoryValue;
    const subCategories = requests?.SuServiceSubCategory?.filter(
      (subCategory) => subCategory.categoryId === categoryId
    );
    setFiltredSubServiceCategory(subCategories);
  }, [requests, availableRequestFields?.Category?.value, serviceCategoryValue]);
  const formItemWithAnotherLabel = useCallback(
    (name, label, placeholder, required = false, isTextArea = false) => {
      return (
        <Form.Item
          name={name}
          label={label}
          validateTrigger={['onChange', 'onSubmit']}
          rules={[{ required: required, message: placeholder }]}
        >
          {isTextArea ? (
            <TextArea placeholder={placeholder} disabled={disabledForm} />
          ) : (
            <Input placeholder={placeholder} disabled={disabledForm} />
          )}
        </Form.Item>
      );
    },
    [disabledForm]
  );

  const formPossibleFields = {
    RespNightWork: (
      <Form.Item
        name="RespNightWork"
        label="Виконавці робіт"
        validateTrigger={['onChange', 'onSubmit']}
        rules={[{ required: true, message: 'Вкажіть виконавців робіт' }]}
      >
        <Input placeholder="Вкажіть виконавців робіт" disabled={disabledForm} />
      </Form.Item>
    ),
    SuServiceSubCategory: (
      <Form.Item
        name="SuServiceSubCategory"
        label="Підкатегорія сервісу"
        validateTrigger={['onChange', 'onSubmit']}
        rules={[{ required: true, message: 'Вкажіть підкатегорію сервісу' }]}
      >
        <PrepareSelect
          defaultValue={availableRequestFields?.SuServiceSubCategory?.value}
          options={prepareSelectOptions(filteredSubServiceCategory)}
          placeholder="Обрати"
          disabledForm={disabledForm}
        />
      </Form.Item>
    ),
  };

  // Локальне поле Коментарі (необов'язкове)
  const optionalSymptomsField = (
    <RequestComments
      label="Коментарі до звернення"
      placeholder="Вкажіть коментарі до звернення"
      disabled={disabledForm}
      required={false}
    />
  );

  const isEditable = availableRequestFields?.Category?.value;

  return (
    <>
      {' '}
      {!isEditable && (
        <Form.Item
          name="ServiceCategory"
          label="Категорія сервісу"
          validateTrigger={['onChange', 'onSubmit']}
          rules={[{ required: true, message: 'Вкажіть категорію сервісу' }]}
        >
          <PrepareSelect
            options={prepareSelectOptions(filterServiceCategory)}
            placeholder="Обрати"
            disabledForm={disabledForm}
          />
        </Form.Item>
      )}
      {[workServiceCategory, marketingServiceCategory].includes(currentServiceCategory) && (
        <div style={{ marginBottom: 12 }}>{formContentItem.RespAltitudeWorks}</div>
      )}
      {currentServiceCategory === workServiceCategory && (
        <>
          {formContentItem.SuWork(/* moment(), moment().add(+1, 'hours') */)}
          {formPossibleFields['SuServiceSubCategory']}
          {formPossibleFields['RespNightWork']}
          {formContentItem.SuTenantResonsible}
          {formContentItem.SuTelNumberTenant}
          {formContentItem.SuLoadingZone} {formContentItem.SuCarNumber}
          {formContentItem.MarketingFile}
          {optionalSymptomsField}
        </>
      )}
      {currentServiceCategory === movingGoodsServiceCategory && (
        <>
          {formContentItem.SuWork(/* moment(), moment().add(+1, 'hours') */)}
          {formPossibleFields['SuServiceSubCategory']}
          {formContentItem.SuTenantResonsible}
          {formContentItem.SuTelNumberTenant}
          {formContentItem.SuLoadingZone}
          {formContentItem.SuCarNumber}{' '}
          <Form.Item
            name="RespNightWork"
            label="Виконавці робіт"
            validateTrigger={['onChange', 'onSubmit']}
          >
            <Input placeholder="Вкажіть виконавців робіт" disabled={disabledForm} />
          </Form.Item>
        </>
      )}
      {currentServiceCategory === marketingServiceCategory && (
        <>
          {formContentItem.SuWork(/* moment(), moment().add(+1, 'hours') */)}
          {formContentItem.SuTenantResonsible}
          {formContentItem.SuTelNumberTenant}
          {formContentItem.SuLoadingZone}
          {formContentItem.SuCarNumber} {formContentItem.MarketingFile}
          {formContentItem.RespNightWork}
          {optionalSymptomsField}
        </>
      )}
      {currentServiceCategory === temporaryEntryServiceCategory && (
        <>
          {formContentItem.SuWork()}
          {formContentItem.SuTenantResonsible}
          {formContentItem.SuTelNumberTenant}
          {formItemWithAnotherLabel(
            'Symptoms',
            'Доступ на вхід для',
            'Вкажіть прізвище, ім’я',
            true
          )}
        </>
      )}
    </>
  );
};

export default RequestCreateContainer;
